import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { VueLocaleService, VueTranslationService } from '@vue/vueframework';
import { Observable, of } from 'rxjs';
import { SessionDataService } from '../services/session-data.service';
import { AccountService } from '../services/account.service';
import { catchError, map } from 'rxjs/operators';
import { Client } from '../types/Client';
import { AccountRecoveryUtil } from '../utils/accountrecovery.utils';

@Injectable({
  providedIn: 'root'
})
export class ClientResolve {
  public constructor(private vueTranslationService: VueTranslationService,
    private vueLocaleService: VueLocaleService,
    private sessionDataService: SessionDataService,
    private accountService: AccountService,
    private accountRecoveryUtil: AccountRecoveryUtil) {}

  public resolve(route: ActivatedRouteSnapshot): Observable<Client> {
    if (!this.sessionDataService.getClient()) {
      return this.accountService.lookupClient(route.params.clientCode, this.sessionDataService.getLocale()).pipe(
        map((client: Client) => {
          this.accountRecoveryUtil.applyClient(client);
          return client;
        }),
        catchError(() => {
          this.accountRecoveryUtil.navigateToNotFound();
          return of(null);
        })
      );
    }

    return of(this.sessionDataService.getClient());
  }
}
